import {GetterTree} from 'vuex';
import {AdminState} from '@/store/modules/Admin/state';
import {RootState} from '@/store';
import {AdminMessage} from '#/Conversations';
import {AdminMessageType} from '@/store/modules/Conversations/state';
import {Stats} from '#/Stats';

export const getters: GetterTree<AdminState, RootState> = {
    hasNewPrivateMessage: (state: AdminState): boolean => !!state.newPrivateMessages.length,
    hasPrivateMessages: (state: AdminState): boolean => !!state.privateMessages.length,
    lastPopMessage: (state: AdminState): AdminMessage => {
        const EulaMessage = state.popMessages.filter(message => message.type === AdminMessageType.EULA);
        if (EulaMessage.length) {
            return EulaMessage[0];
        }

        return state.popMessages[0];
    },
    newPrivateMessage: (state: AdminState): AdminMessage[] => state.newPrivateMessages,
    privateMessages: (state: AdminState): AdminMessage[] => state.privateMessages,
    stats: (state: AdminState): Stats => state.stats,
};
